export const namespace = 'orgManagement';

export const Status = {
  INITIAL: 'initial',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error',
  ACTIVE: 'active',
  DELETED: 'deleted'
};

export const ActionType = {
  LOAD_ORGS: `${namespace}/LOAD_ORGS`,
  LOAD_ACCESSIBLE_ORGS: `${namespace}/LOAD_ACCESSIBLE_ORGS`,
  LOAD_ORGS_BY_IDS: `${namespace}/LOAD_ORGS_BY_IDS`,
  SET_ORGS: `${namespace}/SET_ORGS`,
  SET_ACCESSIBLE_ORGS: `${namespace}/SET_ACCESSIBLE_ORGS`,
  SET_PARTIAL_ORGS: `${namespace}/SET_PARTIAL_ORGS`,
  LOAD_ORG_GROUPS: `${namespace}/LOAD_ORG_GROUPS`,
  SET_ORG_GROUPS: `${namespace}/SET_ORG_GROUPS`,
  UPDATE_ORG_GROUP: `${namespace}/UPDATE_ORG_GROUP`,
  CREATE_ORG_GROUP: `${namespace}/CREATE_ORG_GROUP`,
  DELETE_ORG_GROUP: `${namespace}/DELETE_ORG_GROUP`,
  SET_LOAD_GROUPS_ERROR: `${namespace}/SET_LOAD_GROUPS_ERROR`,
  SET_LOAD_ORG_ERROR: `${namespace}/SET_LOAD_ORG_ERROR`,
  SET_LOAD_ACCESSIBLE_ORGS_ERROR: `${namespace}/SET_LOAD_ACCESSIBLE_ORGS_ERROR`,
  LOGIN_ORG_GROUP: `${namespace}/LOGIN_ORG_GROUP`,
  SWITCH_APP: `${namespace}/SWITCH_APP`,
  LOAD_ENABLE_ENGINES: `${namespace}/LOAD_ENABLE_ENGINES`,
  SET_ENABLE_ENGINES: `${namespace}/SET_ENABLE_ENGINES`
}

export const loadOrgs = () => {
  return (dispatch) => {
    dispatch({
      payload: {},
      type: ActionType.LOAD_ORGS
    })
  }
};

export const loadOrgsByIds = (ids) => {
  return (dispatch) => {
    dispatch({
      payload: {
        ids
      },
      type: ActionType.LOAD_ORGS_BY_IDS
    })
  }
};

export const loadAccessibleOrgs = () => {
  return (dispatch) => {
    dispatch({
      payload: {},
      type: ActionType.LOAD_ACCESSIBLE_ORGS
    })
  }
};

export const loadOrgGroups = (groupIds) => {
  return (dispatch) => {
    dispatch({
      payload: {
        groupIds
      },
      type: ActionType.LOAD_ORG_GROUPS
    })
  }
};

export const setOrgs = (orgs) => {
  return (dispatch) => {
    dispatch({
      payload: {
        orgs
      },
      type: ActionType.SET_ORGS
    })
  }
};

export const setAccessibleOrgs = (orgs) => {
  return (dispatch) => {
    dispatch({
      payload: {
        orgs
      },
      type: ActionType.SET_ACCESSIBLE_ORGS
    })
  }
};

export const setPartialOrgs = (orgs) => {
  return (dispatch) => {
    dispatch({
      payload: {
        orgs
      },
      type: ActionType.SET_PARTIAL_ORGS
    })
  }
};

export const setOrgGroups = (orgGroups) => {
  return (dispatch) => {
    dispatch({
      payload: {
        orgGroups
      },
      type: ActionType.SET_ORG_GROUPS
    })
  }
};

export const updateOrgGroup = (groupInfo) => ({
  payload: {
    groupInfo
  },
  type: ActionType.UPDATE_ORG_GROUP
});

export const createOrgGroup = (groupInfo) => ({
  payload: {
    groupInfo
  },
  type: ActionType.CREATE_ORG_GROUP
});

export const deleteOrgGroup = (id) => ({
  payload: {
    id
  },
  type: ActionType.DELETE_ORG_GROUP
});

export const setLoadGroupsError = () => ({
  payload: {},
  type: ActionType.SET_LOAD_GROUPS_ERROR
});

export const setLoadOrgsError = () => ({
  payload: {},
  type: ActionType.SET_LOAD_ORG_ERROR
});

export const setLoadAccessibleOrgsError = () => ({
  payload: {},
  type: ActionType.SET_LOAD_ACCESSIBLE_ORGS_ERROR
});

export const loginOrgGroup = (id) => ({
  payload: {
    id
  },
  type: ActionType.LOGIN_ORG_GROUP
});

export const switchApp = (appId) => ({
  payload: { id: appId },
  type: ActionType.SWITCH_APP
});

export const loadEnableEngines = () => ({
  payload: {},
  type: ActionType.LOAD_ENABLE_ENGINES
});

export const setEnableEngines = (enableEngines) => ({
  payload: enableEngines,
  type: ActionType.SET_ENABLE_ENGINES
});